import { TabView, TabPanel } from "primereact/tabview";
import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { API_PORT, API_IP } from "./AppConfig/AppConfig";
import { SelectButton } from "primereact/selectbutton";
import { Paginator } from "primereact/paginator";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";
import Moment from "react-moment";
import "moment/locale/tr";

export default function LogPage({ setSidebarVisible }) {
  const items = Array.from({ length: 5 }, (v, i) => i);

  const bodyTemplate = () => {
    return <Skeleton></Skeleton>;
  };
  const handleShowDialog = (content) => {
    setDialogContent(content);
    setShowDialog(true);
  };

  const hideDialog = () => {
    setShowDialog(false);
    setDialogContent("");
  };

  const [dataLoading, setDataLoading] = useState(true);
  const [dialogContent, setDialogContent] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [loginEventData, setLoginEventData] = useState([]);
  const [logoutEventData, setLogoutEventData] = useState([]);
  const [passwordResetTokenData, setPasswordResetTokenData] = useState([]);
  const [passwordResetEventData, setPasswordResetEventData] = useState([]);
  const [dataAuditData, setDataAuditData] = useState([]);
  const [jwtEventData, setJwtEventData] = useState([]);
  const [loginVerifyEventData, setLoginVerifyEventData] = useState([]);
  const [loginVerifyTokenData, setLoginVerifyTokenData] = useState([]);
  const [size, setSize] = useState("small");
  const [appToken, setAppToken] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalElements, setTotalElements] = useState(null);
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);

    switch (activeTabIndex) {
      case 0:
        getLoginEventData();
        break;
      case 1:
        getLoginVerifyEventData();
        break;
      case 2:
        getLoginVerifyTokenData();
        break;
      case 3:
        getDataAuditEventData();
        break;
      case 4:
        getLogoutEventData();
        break;
      case 5:
        getJwtEventData();
        break;
      case 6:
        getPasswordResetTokenData();
        break;
      case 7:
        getPasswordResetEventData();
        break;
      default:
        break;
    }
  };
  const onTabChange = (event) => {
    setActiveTabIndex(event.index);

    // Call the corresponding API function based on the active tab index
    switch (event.index) {
      case 0:
        getLoginEventData();
        break;
      case 1:
        getLoginVerifyEventData();
        break;
      case 2:
        getLoginVerifyTokenData();
        break;
      case 3:
        getDataAuditEventData();
        break;
      case 4:
        getLogoutEventData();
        break;
      case 5:
        getJwtEventData();
        break;
      case 6:
        getPasswordResetTokenData();
        break;
      case 7:
        getPasswordResetEventData();
        break;
      default:
        break;
    }
  };

  const getLoginEventData = async () => {
    try {
      setDataLoading(true);
      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/login-event?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setLoginEventData(data.data); // API'den dönen veriyi state'e ata
      setTotalElements(data.properties.totalElements);
      setDataLoading(false);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(false);
    }
  };
  const getLogoutEventData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/logout-event?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );
      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setLogoutEventData(data.data);
      setDataLoading(false);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(false);
    }
  };
  const getLoginVerifyEventData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/loginVerifyEvent/findAll?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setTotalElements(data.totalElements);
      setLoginVerifyEventData(data.content);
      setDataLoading(false);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(false);
    }
  };

  const getLoginVerifyTokenData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/loginVerifyToken/findAll?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setTotalElements(data.totalElements);
      setLoginVerifyTokenData(data.content);
      setDataLoading(false);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(false);
    }
  };

  const getJwtEventData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/jwt-event?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setJwtEventData(data.data);
      setTotalElements(data.properties.totalElements);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);

      console.error("API'den veri alınırken bir hata oluştu:", error);
    }
  };

  const getPasswordResetTokenData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/password-reset-token?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setPasswordResetTokenData(data.data);
      setTotalElements(data.properties.totalElements);
      setDataLoading(false);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(true);
    }
  };

  const getPasswordResetEventData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/password-reset-event?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setPasswordResetEventData(data.data); // API'den dönen veriyi state'e ata
      setTotalElements(data.properties.totalElements);
      setDataLoading(false);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(false);
    }
  };

  const getDataAuditEventData = async () => {
    try {
      setDataLoading(true);

      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/dataAudit/findAll?page=${
          first / rows
        }&size=${rows}&sort=id,desc`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`, // Token'ı Authorization başlığına ekleyin
          },
        }
      );

      if (!response.ok) {
        throw new Error("Kullanıcı verisi çekme hatası");
      }

      const data = await response.json();
      setDataAuditData(data.content); // API'den dönen veriyi state'e ata
      setTotalElements(data.totalElements);
      setDataLoading(false);
      console.log("DataAuditSon");
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
      setDataLoading(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const tokenResponse = await fetch(
          `http://${API_IP}:${API_PORT}/api/auth`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: "kimlik",
              password: "ff147b70-6b7a-482a-82f4-23ecc5186c54",
            }),
          }
        );
        if (!tokenResponse.ok) {
          throw new Error("Token alınırken bir hata oluştu");
        }

        const tokenData = await tokenResponse.json();
        setAppToken(tokenData.data.token);
        getLoginEventData();
      } catch (error) {
        console.error("catch oluştu:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (appToken !== null) {
      switch (activeTabIndex) {
        case 0:
          getLoginEventData();
          break;
        case 1:
          getLoginVerifyEventData();
          break;
        case 2:
          getLoginVerifyTokenData();
          break;
        case 3:
          getDataAuditEventData();
          break;
        case 4:
          getLogoutEventData();
          break;
        case 5:
          getJwtEventData();
          break;
        case 6:
          getPasswordResetTokenData();
          break;
        case 7:
          getPasswordResetEventData();
          break;
        default:
          break;
      }
    }
  }, [appToken, activeTabIndex, first, rows]);

  const loginEventTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const loginVerifyTokenTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const loginVerifyEventTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const jwtEventTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const logutEventTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const passwordResetTokenTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const passwordResetEventTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const dataAuditTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  return (
    <div className="card py-4 px-40">
      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>

      <Dialog
        header="Detayı"
        visible={showDialog}
        onHide={hideDialog}
        style={{ width: "50vw" }}
      >
        <pre className="p-4">
          {dialogContent
            .replace("{", "")
            .replace("}", "")
            .split(",")
            .map((item) => (
              <div key={item}>{item.replace(/"/g, "").trim()}</div>
            ))}
        </pre>
      </Dialog>
     
      <TabView onTabChange={onTabChange} activeIndex={activeTabIndex}>
        <TabPanel header="Giriş İşlemleri" headerTemplate={loginEventTab}>
          <div className="relative h-screen flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="IP" body={bodyTemplate}></Column>
                <Column header="Giriş Tarihi" body={bodyTemplate}></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={loginEventData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-user"
                        className="py-2 w-48 px-4 gap-2 bg-violet-200 text-black"
                        value={rowData.yid.id}
                      ></Tag>
                    )}
                    header="Yerlem ID"
                  />
                  <Column
                    field="ip"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-flag"
                        className="py-2 px-4 w-48 gap-2 bg-blue-100 text-black"
                        value={rowData.ip}
                      ></Tag>
                    )}
                    header="IP"
                  />
                  <Column
                    field="time"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i> 
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.time}
                        </Moment>
                      </span>
                    )}
                    header="Giriş Tarihi"
                  />
                </DataTable>
                <Paginator
                  className="z-2 my-2"
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel
          header="Giriş Doğrulama İşlemleri"
          headerTemplate={loginVerifyEventTab}
        >
          <div className="relative h-screen rounded-3xl flex flex-col  items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="Token" body={bodyTemplate}></Column>
                <Column header="IP" body={bodyTemplate} />
                <Column
                  header="Doğrulama Oluşum Tarihi"
                  body={bodyTemplate}
                ></Column>
                <Column
                  header="Doğrulama Bitiş Tarihi"
                  body={bodyTemplate}
                ></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={loginVerifyEventData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-user"
                        className="py-2 w-48 px-4 gap-2 bg-violet-200 text-black"
                        value={rowData.yid.id}
                      ></Tag>
                    )}
                    header="Yerlem ID"
                  />
                  <Column
                    field="token"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-key"
                        className="py-2 px-4 w-28 gap-2 bg-green-200 text-black"
                        value={rowData.token}
                      ></Tag>
                    )}
                    header="Token"
                  />
                  <Column
                    field="ip"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-flag"
                        className="py-2 px-4 w-48 gap-2 bg-blue-100 text-black"
                        value={rowData.ip}
                      ></Tag>
                    )}
                    header="IP"
                  />
                  <Column
                    field="validityBeginTime"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityBeginTime}
                        </Moment>
                      </span>
                    )}
                    header="Doğrulama Oluşum Tarihi"
                  />
                  <Column
                    field="validityEndTime"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityEndTime}
                        </Moment>
                      </span>
                    )}
                    header="Doğrulama Bitiş Tarihi"
                  />
                 
                </DataTable>
                <Paginator
                  className="z-2 my-2"
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel
          header="Giriş Doğrulama Tokenleri"
          headerTemplate={loginVerifyTokenTab}
        >
          <div className="relative h-screen rounded-3xl flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="Token" body={bodyTemplate}></Column>
                <Column
                  header="Doğrulama Oluşum Tarihi"
                  body={bodyTemplate}
                ></Column>
                <Column
                  header="Doğrulama Bitiş Tarihi"
                  body={bodyTemplate}
                ></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={loginVerifyTokenData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-user"
                        className="py-2 px-4 w-48 gap-2 bg-violet-200 text-black"
                        value={rowData.yid.id}
                      ></Tag>
                    )}
                    header="Yerlem ID"
                  />
                  <Column
                    field="token"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-key"
                        className="py-2 px-4 w-28 gap-2 bg-green-200 text-black"
                        value={rowData.token}
                      ></Tag>
                    )}
                    header="Token"
                  />
                  <Column
                    field="validityBeginTime"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityBeginTime}
                        </Moment>
                      </span>
                    )}
                    header="Doğrulama Oluşum Tarihi"
                  />
                  <Column
                    field="validityEndTime"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityEndTime}
                        </Moment>
                      </span>
                    )}
                    header="Doğrulama Bitiş Tarihi"
                  />
                </DataTable>
                <Paginator
                  className="z-2 my-2"
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel header="Veri İşlemleri" headerTemplate={dataAuditTab}>
          <div className="relative h-screen rounded-3xl flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Uygulama Adı" body={bodyTemplate}></Column>
                <Column header="Eski Veri" body={bodyTemplate}></Column>
                <Column header="Yeni Veri" body={bodyTemplate}></Column>
                <Column header="Tablosu" body={bodyTemplate}></Column>
                <Column header="Kullanıcı" body={bodyTemplate}></Column>
                <Column header="İşlem" body={bodyTemplate}></Column>
                <Column header="Tarih" body={bodyTemplate}></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={dataAuditData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    header="Log Numarası"
                    className="text-black"
                    field="id"
                  ></Column>
                  <Column
                    header="Uygulama Adı"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-th-large"
                        className="py-2 px-4 w-56 gap-2 bg-violet-200 text-black"
                        value={rowData.appname}
                      ></Tag>
                    )}
                    field="appname"
                  ></Column>
                  <Column
                    header="Eski Veri"
                    body={(rowData) =>
                      rowData.originalData !== null ? (
                        <Button
                          className="h-full"
                          label="Görüntüle"
                          onClick={() => handleShowDialog(rowData.originalData)}
                          severity="info"
                          icon="pi pi-search"
                          text
                        />
                      ) : (
                        <Button
                          className="h-full"
                          label="Görüntüle"
                          icon="pi pi-search"
                          disabled
                          severity="secondary"
                          text
                        />
                      )
                    }
                    field="originalData"
                  ></Column>
                  <Column
                    header="Yeni Veri"
                    body={(rowData) =>
                      rowData.newData !== null ? (
                        <Button
                          className="h-full"
                          label="Görüntüle"
                          icon="pi pi-search"
                          onClick={() => handleShowDialog(rowData.newData)}
                          severity="info"
                          text
                        />
                      ) : (
                        <Button
                          className="h-full"
                          label="Görüntüle"
                          disabled
                          severity="secondary"
                          icon="pi pi-search"
                          text
                        />
                      )
                    }
                    field="newData"
                  ></Column>
                  <Column
                    header="Tablosu"
                    className="text-black"
                    field="table"
                  ></Column>
                  <Column
                    header="Kullanıcı"
                    className="text-black"
                    field="user"
                  ></Column>
                  <Column
                    header="İşlem"
                    body={(rowData) =>
                      rowData.action === "INSERT" ? (
                        <Tag
                          className="w-24 py-2"
                          severity="success"
                          value="EKLEME"
                        ></Tag>
                      ) : rowData.action === "UPDATE" ? (
                        <Tag
                          className="w-24 py-2"
                          severity="warning"
                          value="GÜNCELLEME"
                        ></Tag>
                      ) : rowData.action === "DELETE" ? (
                        <Tag
                          className="w-24 py-2"
                          severity="danger"
                          value="SİLME"
                        ></Tag>
                      ) : (
                        " "
                      )
                    }
                    field="action"
                  ></Column>
                  <Column
                    header="Tarih"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.txstamp}
                        </Moment>
                      </span>
                    )}
                    field="txstamp"
                  ></Column>
                </DataTable>
                <Paginator
                  className="z-2 my-2"
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel header="Çıkış İşlemleri" headerTemplate={logutEventTab}>
          <div className="relative h-screen rounded-3xl flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="Platform" body={bodyTemplate}></Column>
                <Column header="IP" body={bodyTemplate}></Column>
                <Column header="Tarih" body={bodyTemplate}></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={logoutEventData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    className="text-black"
                    header="Yerlem ID"
                  />
                  <Column
                    field="platform"
                    className="text-black"
                    header="Platform"
                  />
                  <Column field="ip" className="text-black" header="IP" />
                  <Column field="time" className="text-black" header="Tarih" />
                </DataTable>
                <Paginator
                  className="z-2 my-2" // "z-index" değerini artırarak en önde durmasını sağlayın
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel header="JWT İşlemleri" headerTemplate={jwtEventTab}>
          <div className="relative h-screen rounded-3xl flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="Token" body={bodyTemplate}></Column>
                <Column header="IP" body={bodyTemplate}></Column>
                <Column header="Oluşturma Tarihi" body={bodyTemplate}></Column>
                <Column header="Sona Erme Tarihi" body={bodyTemplate}></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={jwtEventData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-user"
                        className="py-2 w-48 px-4 gap-2 bg-violet-200 text-black"
                        value={rowData.yid.id}
                      ></Tag>
                    )}
                    header="Yerlem ID"
                  />
                  <Column
                    field="token"
                    header="Token"
                    body={(rowData) => (
                      <Button
                        className="h-full"
                        label="Görüntüle"
                        onClick={() => handleShowDialog(rowData.token.replace(/(.{60})/g, "$1\n").trim())}
                        severity="info"
                        text
                        icon="pi pi-search"
                      />
                    )}
                  />
                  <Column
                    field="ip"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-flag"
                        className="py-2 px-4 w-48 gap-2 bg-blue-100 text-black"
                        value={rowData.ip}
                      ></Tag>
                    )}
                    header="IP"
                  />
                  <Column
                    field="issuedAt"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.issuedAt}
                        </Moment>
                      </span>
                    )}
                    header="Oluşturma Tarihi"
                  />
                  <Column
                    field="expirationAt"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.expirationAt}
                        </Moment>
                      </span>
                    )}
                    header="Sona Erme Tarihi"
                  />
                </DataTable>
                <Paginator
                  className="z-2 my-2"
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel
          header="Şifre Sıfırlama Tokenleri"
          headerTemplate={passwordResetTokenTab}
        >
          <div className="relative h-screen rounded-3xl flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="Token" body={bodyTemplate}></Column>
                <Column
                  header="Geçerlilik Başlama Tarihi"
                  body={bodyTemplate}
                ></Column>
                <Column
                  header="Geçerlilik Bitiş Tarihi"
                  body={bodyTemplate}
                ></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={passwordResetTokenData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-user"
                        className="py-2 px-4 w-48 gap-2 bg-violet-200 text-black"
                        value={rowData.yid.id}
                      ></Tag>
                    )}
                    header="Yerlem ID"
                  />
                  <Column
                    field="token"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-key"
                        className="py-2 w-28 px-4 gap-2 bg-green-200 text-black"
                        value={rowData.token}
                      ></Tag>
                    )}
                    header="Token"
                  />
                  <Column
                    field="validityBeginTime"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityBeginTime}
                        </Moment>
                      </span>
                    )}
                    header="Geçerlilik Başlama Tarihi"
                  />
                  <Column
                    field="validityEndTime"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityEndTime}
                        </Moment>
                      </span>
                    )}
                    header="Geçerlilik Bitiş Tarihi"
                  />
                </DataTable>
                <Paginator
                  className="z-2 my-2"
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel
          header="Şifre Sıfırlama İşlemleri"
          headerTemplate={passwordResetEventTab}
        >
          <div className="relative h-screen rounded-3xl flex flex-col items-center">
            {dataLoading ? (
              <DataTable
                value={items}
                style={{ width: "100%" }}
                size={size}
                className="p-datatable-striped"
              >
                <Column header="Log Numarası" body={bodyTemplate}></Column>
                <Column header="Yerlem ID" body={bodyTemplate}></Column>
                <Column header="IP" body={bodyTemplate}></Column>
                <Column header="Yeni Şifre" body={bodyTemplate}></Column>
                <Column header="Eski Şifre" body={bodyTemplate}></Column>
                <Column header="Tarih" body={bodyTemplate}></Column>
              </DataTable>
            ) : (
              <>
                <DataTable
                  value={passwordResetEventData}
                  size={size}
                  style={{ width: "100%" }}
                >
                  <Column
                    field="id"
                    className="text-black"
                    header="Log Numarası"
                  />
                  <Column
                    field="yid.id"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-user"
                        className="py-2 px-4 w-48 gap-2 bg-violet-200 text-black"
                        value={rowData.yid.id}
                      ></Tag>
                    )}
                    header="Yerlem ID"
                  />
                  <Column
                    field="ip"
                    body={(rowData) => (
                      <Tag
                        icon="pi pi-flag"
                        className="py-2 px-4 w-48 gap-2 bg-blue-100 text-black"
                        value={rowData.ip}
                      ></Tag>
                    )}
                    header="IP"
                  />
                  <Column
                    field="newPassword"
                    className="text-black"
                    header="Yeni Şifre"
                  />
                  <Column
                    field="oldPassword"
                    className="text-black"
                    header="Eski Şifre"
                  />
                  <Column
                    field="time"
                    className="text-black"
                    body={(rowData) => (
                      <span>
                        <i className="pi pi-calendar mr-2"></i>
                        <Moment parse="DD-MM-YYYY HH:mm" format="DD-MMM-YYYY HH:mm" locale="tr" >
                          {rowData.validityBeginTime}
                        </Moment>
                      </span>
                    )}
                    header="Tarih"
                  />
                </DataTable>
                <Paginator
                  classname="mt-4 z-1 "
                  first={first}
                  rows={rows}
                  totalRecords={totalElements}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
}
